<template>
  <ScatterChart :height="100" :chartdata='chartdata' :options="options" />
</template>

<script>
import ScatterChart from '@/components/charts/scatter'

export default {
  name: 'AlertTimeline',
  components: {
    ScatterChart
  },
  props: {
    period: {
      type: String
    },
    date: {
      type: String
    },
    alerts: {
      type: Object
    }
  },
  data () {
    return {
      chartdata: null,
      matrix: {
        P1: {
          label: 'critical',
          colour: 'rgba(180, 35, 35, 0.7)'
        },
        P2: {
          label: 'downgraded',
          colour: 'rgba(240, 161, 112, 0.7)'
        },
        P3: {
          label: 'task',
          colour: 'rgba(0, 153, 204, 0.7)'
        },
        P4: {
          label: 'warning',
          colour: 'rgba(255, 214, 51, 0.7)'
        },
        P5: {
          label: 'info',
          colour: 'rgba(56, 118, 29, 0.7)'
        }
      }
    }
  },
  methods: {
    getMin: function (period, date) {
      switch (period) {
        case 'week':
          return this.$moment(date, 'YYYY-WW').startOf('isoWeek').format('YYYY-MM-DD HH:mm')
        case 'month':
          return this.$moment(this.date, 'YYYY-MM').startOf('month').format('YYYY-MM-DD HH:mm')
        default:
          break
      }
    },
    getMax: function (period, date) {
      switch (period) {
        case 'week':
          return this.$moment(date, 'YYYY-WW').endOf('isoWeek').format('YYYY-MM-DD HH:mm')
        case 'month':
          return this.$moment(this.date, 'YYYY-MM').endOf('month').format('YYYY-MM-DD HH:mm')
        default:
          break
      }
    },
    fillchartdata: function () {
      var datasets = []

      for (const priority in this.alerts) {
        var data = []
        for (const alert of this.alerts[priority]) {
          data.push({
            x: this.$moment.unix(alert.timestamp).utc().format('YYYY-MM-DD HH:mm'),
            y: 1
          })
        }

        datasets.push({
          label: this.matrix[priority].label,
          backgroundColor: this.matrix[priority].colour,
          data: data
        })
      }

      this.options = {
        tooltips: {
          callbacks: {
            label: function (context) {
              var dataset = datasets[context.datasetIndex]
              return dataset.data[context.index].x
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              display: false
            },
            gridLines: {
              display: false
            }
          }],
          xAxes: [{
            type: 'time',
            time: {
              unit: 'day',
              tooltipFormat: 'MMM DD'
            },
            ticks: {
              min: this.getMin(this.period, this.date),
              max: this.getMax(this.period, this.date)
            },
            gridLines: {
              display: true
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false
      }

      this.chartdata = {
        datasets: datasets
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/AlertTimeline.vue